let dicUtils = {}

dicUtils.config = {
    province: [
        {key: 110000,value: '北京'},
        {key: 2,value: '上海'}
    ]
}

/**
 * 配置本地字典数据，这里的数据会和后端字典数据合并
 */
export default dicUtils
